// Port of api/fuel/app/classes/controller/api/monty/listing/create.php
import DB from 'offline/db'
import Listing from 'offline/model/listing'
import {
	LIST_TYPE_AUTOMATED,
	LIST_FREQUENCY_ADHOC,
	createEdition,
	currentUserId,
	ensureUniqueListingSlug,
	invalid,
	loadOwnedContext,
	persist,
	unauthorised
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var ownerContext = null
	var data = params.data || {}
	var name = String(data.name || '').trim()
	var description = String(data.description || '').trim()
	var listType = parseInt(data.type, 10) || 0
	var frequency = parseInt(data.frequency, 10) || 0
	var ranked = parseInt(data.ranked, 10) ? 1 : 0
	var columns = []
	var listingId = 0
	var listing = null

	if (!userId) return unauthorised()

	ownerContext = loadOwnedContext(params, userId)
	if (!ownerContext) return unauthorised()

	if (!name || (listType !== 1 && listType !== 2)) return invalid()

	if (ranked) {
		columns.push({ type: 'rank' })
	}
	columns.push({ type: 'avatar' })
	columns.push({ type: 'name' })

	if (ranked) {
		columns.push({
			type: 'rating',
			context: (ownerContext.type === 2 || ownerContext.type === 3) ? 'group' : 'user'
		})
	}

	if (listType !== LIST_TYPE_AUTOMATED) {
		frequency = LIST_FREQUENCY_ADHOC
	}

	DB.run('INSERT INTO list (group_id, user_id, buddies_id, list_public, list_ready, list_slug, list_template, list_date_create, list_date_start, list_date_update, list_type, list_frequency, list_ranked, list_name, list_description, list_filter, list_columns, list_count_editions, list_count_progress) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		ownerContext.type === 2 ? ownerContext.owner.get_id() : 0,
		userId,
		ownerContext.type === 3 ? ownerContext.owner.get_id() : 0,
		parseInt(data.public, 10) ? 1 : 0,
		1,
		'',
		0,
		Math.floor(Date.now() / 1000),
		0,
		0,
		listType,
		frequency,
		ranked,
		name,
		description,
		JSON.stringify({}),
		JSON.stringify(columns),
		0,
		0
	])

	listingId = DB.scalar('SELECT last_insert_rowid()')
	DB.run('UPDATE list SET list_slug = ? WHERE list_id = ?', [
		ensureUniqueListingSlug(
			userId,
			ownerContext.type === 2 ? ownerContext.owner.get_id() : 0,
			ownerContext.type === 3 ? ownerContext.owner.get_id() : 0,
			name
		),
		listingId
	])

	listing = Listing.with_id(listingId)
	createEdition(listing, Math.floor(Date.now() / 1000), true, [])
	listing = Listing.with_id(listingId)

	return persist(listing.to_array())
}
